import React from "react";
import "./style.css";

export default function Booking(props) {
    return (
        <div className={`page bookingPage transition ${props.className}`}>
                <iframe src="https://app.acuityscheduling.com/schedule.php?owner=38108896&ref=embedded_csp" title="Schedule Appointment" width="100%" height="100%" frameBorder="0" allow="payment"></iframe><script src="https://embed.acuityscheduling.com/js/embed.js" type="text/javascript"></script>
        </div>
    )
}